var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 361,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 361",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m127.843868 360.087912-104.1821537-28.92167-23.21652749-260.4005277h255.10962619l-23.241143 260.3597367z",
    fill: "#264de4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m212.416703 314.546637 19.861099-222.4893183h-104.277802v245.8929233z",
    fill: "#2965f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ebebeb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.6685714 188.636132 2.8624176 31.936703h71.469011v-31.936703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.917011 123.994725 2.9032088 31.937407h77.1797802v-31.937407z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 271.580132-.139956.037275-35.5685275-9.60422-2.2737583-25.471297h-32.0597802l4.4743736 50.145758 65.4206594 18.161231.146989-.040791z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.4835165 0h38.6813187v16.1758242h-22.5054945v16.1758242h22.5054945v16.1758241h-38.6813187z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m106.901099 0h38.681319v14.0659341h-22.505495v2.8131868h22.505495v32.3516483h-38.681319v-14.7692307h22.505494v-2.8131869h-22.505494z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m153.318681 0h38.681319v14.0659341h-22.505495v2.8131868h22.505495v32.3516483h-38.681319v-14.7692307h22.505495v-2.8131869h-22.505495z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m202.126769 188.636132 5.765627-64.641407h-80.002814v31.937407h45.00255l-2.906022 32.704h-42.096528v31.936703h39.326945l-3.707076 41.419956-35.619869 9.614066v33.22655l65.472704-18.145759.480351-5.395692 7.504879-84.079824z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css-3.bb4a27cf82d37d471d538107096e6b1b.svg";
export { ForwardRef as ReactComponent };